export function fmtSigned(value: number) {
  return value > 0 ? `+${value.toFixed(2)}` : value.toFixed(2)
}

export function playerFromLabel(label: string) {
  return label.replace(/^R\d+\s+/, '')
}

export function initials(name: string) {
  return name.split(/[\s.-]+/).reduce((value, part) => {
    if (!part || value.length >= 2) return value
    return value + part[0]
  }, '')
}

export function teamCode(name: string) {
  const codes: Record<string, string> = {
    'fent folders': 'RC',
    wadeland: 'AM',
    'Real Manhattan': 'TH',
    Leyverpool: 'LY',
    'Old Lady': 'NC',
    'Chunky jeet FC': 'AJ',
    A: 'AS',
    'Big Micha': 'HK',
    'Son Doku': 'JK',
    MBOOMO: 'RS',
    Yanited: 'AD',
    'Hookah Doncic': 'AN',
    'Shyam’s Your Daddy': 'SK',
  }

  return codes[name] ?? initials(name)
}
